import { createRemoteReducer, RemoteReducer } from "types/Remote"
import { FormActivity } from "types/Template"

export const formActivityReducer: RemoteReducer<FormActivity[]> =
  createRemoteReducer("formActivity")
